<template>
  <div class="solution">
      <!-- 第一部分 -->
      <div class="solution_1 pd_b20">
        <p class="title color_fff txt_c">解决方案</p>
      </div>
      <!-- 第二部分 -->
      <div class="solution_2 pd_b20">
        <div class="clear_fd solution_2_ul">
          <div class="solution_2_li ft_l">
            <p class="solution_2_li_title">配电</p>
            <p class="solution_2_li_content mt35">依据车辆数量、运营特点、应用场景进行灵活设计车桩配比，进行配电统一规划设计。</p>
          </div>
          <div class="solution_2_li ft_l">
            <p class="solution_2_li_title">充电</p>
            <p class="solution_2_li_content mt35">采用一体式直流充电机，具备有源功率因数校正功能，可安全接入电网，效率高达96%；国际接口，双枪切换充电，智能充电，无人值守，节省人力。</p>
          </div>
          <div class="solution_2_li ft_l">
            <p class="solution_2_li_title">工程</p>
            <p class="solution_2_li_content mt35">在合适充电场地的基础上进行统一规划设计，防雨、防撞、防雷等专业设计，安全、快捷的停车和充电。</p>
          </div>
          <div class="solution_2_li ft_l">
            <p class="solution_2_li_title">监控</p>
            <p class="solution_2_li_content mt35">充电过程中可对电池电压、电流、SOC、温度进行实时监控，并进行安全预警。智能调度统计充电电量、电费、生成报表。</p>
          </div>
        </div>
      </div>
      <!-- 第三部分 -->
      <div :class="'solution_3 pd_b20 solution_3_bg'+select3">
        <div class="clear_fd">
          <div class="ft_l solution_3_ul">
            <div class="solution_3_ul_wire"></div>
            <div :class="select3 == item.id ? 'solution_3_nav solution_3_select' : 'solution_3_nav'" v-for="(item,index) in list3" :key="index" @click="cutNav(item.id)">
              {{item.title}}
              <div :class="select3 == item.id ? 'solution_3_nav_select' : 'hide'"></div>
            </div>
          </div>
          <div class="ft_l solution_3_content pl50 mt30">
            <p class="title color_fff mb30">{{content3.title}}</p>
            <p class="solution_3_content_txt" v-for="(item,index) in content3.list" :key="index">{{item}}</p>
          </div>
        </div>
        <div class="solution_3_logo hide">{{logo3[select3]}}</div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      select3: 1,
      logo3: {
        1: "LOGISTICS",
        2: "PUBLIC",
        3: "NET ABOUT",
        4: "ENVIRONMENTAL"
      },
      list3: [
        {
          id: 1,
          title: "物流",
          bgClass: "solution_3_bg1",
          content: [
            "场地方合作：场地资源充分利用、提升服务能力",
            "物流企业合作：解决充电难题、加速新能源汽车切换、降低企业运营成本",
            "车辆运营商合作：拓宽用户渠道、直达新能源终端用户",
            "整车企业合作：提高新能源汽车销售业务和售后网点服务"
          ]
        },
        {
          id: 2,
          title: "公交",
          bgClass: "solution_3_bg2",
          content: [
            "场地方合作：场地资源充分利用、提升服务能力",
            "公交集团类企业合作：解决充电难题、加速新能源公交车辆切换",
            "通勤车运营商合作：拓宽企业用户渠道、直达新能源公交和巴士的终端用户",
            "整车企业合作：提高合作伙伴新能源汽车销售业务和售后网点服务"
          ]
        },
        {
          id: 3,
          title: "网约",
          bgClass: "solution_3_bg3",
          content: [
            "场地方合作：场地资源充分利用、提升服务能力",
            "网约车和出租车类企业合作：直达新能源汽车终端用户，提升充电效率和业务效益",
            "经销商、整车企业合作：提高合作伙伴新能源乘用汽车销售业务和售后网点服务"
          ]
        },
        {
          id: 4,
          title: "环卫",
          bgClass: "solution_3_bg4",
          content: [
            "场地方合作：场地资源充分利用、提升服务能力",
            "环卫部门合作：根据城市道路具体情况提出合理经济高效的充电方案，以匹配不同道路保洁解决方案",
            "经销商、整车企业合作：提高合作伙伴新能源环卫汽车销售业务和售后网点服务"
          ]
        }
      ],
      content3: {
        title: "物流",
        list: [
          "场地方合作：场地资源充分利用、提升服务能力",
          "物流企业合作：解决充电难题、加速新能源汽车切换、降低企业运营成本",
          "车辆运营商合作：拓宽用户渠道、直达新能源终端用户",
          "整车企业合作：提高新能源汽车销售业务和售后网点服务"
        ]
      }
    };
  },
  methods: {
    cutNav: function(id) {
      var selevtId = id;
      this.select3 = selevtId;
      for (var i = 0; i < this.list3.length; i++) {
        if (selevtId == this.list3[i].id) {
          var obj = {
            title: this.list3[i].title,
            list: this.list3[i].content
          };
          this.content3 = obj;
          return true;
        }
      }
    }
  }
};
</script>

<style>
/* 第一部分样式 */
.solution_1 {
  height: 300px;
  background-image: url("../assets/solution/solution_bg_1.png");
  background-size: 100% 100%;
  padding-top: 176px;
}
/* 第二部分样式 */
.solution_2 {
  height: 726px;
  background-image: url("../assets/solution/solution_bg_2.png");
  background-size: 100% 100%;
  padding-top: 48px;
}
.solution_2_ul {
  background-image: url("../assets/solution/solution_fa.png");
  background-size: 100% 100%;
}
.solution_2_li {
  width: 50%;
  height: 314px;
  padding: 60px 45px;
  box-sizing: border-box;
}
.solution_2_li_title {
  font-size: 27px;
  font-weight: bold;
  color: #333333;
}
.solution_2_li_content {
  font-size: 17px;
  color: #666666;
}
/* 第三部分样式 */
.solution_3 {
  height: 700px;
  background-size: 100% 100%;
  padding-top: 138px;
  position: relative;
}
.solution_3_bg1 {
  background-image: url("../assets/solution/solution_bg_3_1.png");
  /* opacity: 1;
  animation: showImg 1s linear; */
}
.solution_3_bg2 {
  background-image: url("../assets/solution/solution_bg_3_2.png");
  /* opacity: 1;
  animation: showImg1 1s linear; */
}
.solution_3_bg3 {
  background-image: url("../assets/solution/solution_bg_3_3.png");
  /* opacity: 1;
  animation: showImg 1s linear; */
}
.solution_3_bg4 {
  background-image: url("../assets/solution/solution_bg_3_4.png");
  /* opacity: 1;
  animation: showImg 1s linear; */
}
.solution_3_ul {
  position: relative;
}
.solution_3_ul_wire {
  position: absolute;
  width: 2px;
  background-color: #a8c2cf;
  top: -37px;
  bottom: -37px;
  right: 0;
}
.solution_3_nav {
  width: 175px;
  height: 76px;
  line-height: 76px;
  text-align: center;
  color: #ffffff;
  font-size: 24px;
  margin-top: 20px;
  box-sizing: border-box;
  padding-left: 20px;
  position: relative;
}
.solution_3_nav_select {
  position: absolute;
  background-color: #1861a7;
  width: 4px;
  top: 0;
  bottom: 0;
  right: -1px;
}
.solution_3_select {
  background-image: url("../assets/solution/solution_3_nav.png");
}
.solution_3_content {
  width: 75%;
}
.solution_3_content_txt {
  font-size: 23px;
  padding: 15px 0;
  color: #edf3f6;
}
.solution_3_logo {
  position: absolute;
  font-size: 136px;
  color: #608eab;
  right: 50px;
}
/* @keyframes showImg {
  0%{
    opacity: 0.5;
  }
  100%{
    opacity: 1;
  }
}
@keyframes showImg1 {
  0%{
    opacity: 0.5;
  }
  100%{
    opacity: 1;
  }
} */
</style>


// WEBPACK FOOTER //
// src/components/solution.vue